<!-- Label padrao -->

<template>
    <label :class="_class"> 
        <!-- <span v-if="badgeHelp" href="#" class="badge badge-silver" data-toggle="tooltip" data-placement="top" :title="help">?</span>  -->
        {{ _label }} 
        <span v-if="titleAddButton" href="#" class="badge-incluir badge-blue" style="color: white" @click="handleAddButton"> {{ titleAddButton }} </span> 
        <i class="fa fa-question-circle-o" style="color: #07a7cf;" v-if="badgeHelp" data-toggle="tooltip" data-placement="top" :title="help" aria-hidden="true"></i>
    </label>
</template>

<script>
//https://br.vuejs.org/v2/guide/components.html#Usando-v-on-com-Eventos-Personalizados

export default {
    name: 'v-label',
    props: {
      label: { type: String },
      metadataField: { type: Object },
      titleAddButton: { type: String },
      title: { type: String },
    },

    data () {
      return {
        vlabel: '',
        help: '',
        badgeHelp: false,
        badgeNew: false,
      }
    },

    computed: {

        _class: function () {
          if (this.class) {
            return this.class
          } else {
            return 'lbl-edit'
          }
        },

        _label: function () {
          if (this.label) {
            return this.label
          } else
          if (this.metadataField) {
            if (this.metadataField.label) {
              return this.metadataField.label
            } 
          } else {
            return this.label
          }
        }

    },

    methods: {
      handleAddButton () {
        this.$emit('clickAdd')
      },
    },

    mounted () {
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    created () {
      if (this.metadataField) {
        if (this.metadataField.help) {
          this.badgeHelp = true
          this.help = this.metadataField.help
        }
      }
      if (this.title) {
          this.badgeHelp = true
          this.help = this.title
      }
    },
   
}
</script>

<style>

.tooltip {
    z-index: 10000000; 
}

</style>



// WEBPACK FOOTER //
// src/components/label.vue